<div class="dashboard-page">

  <div class="row justify-content-between pt-3 dashboard-upper-part">
    <div class="col-12 col-xl-6 pl-0 pr-2 pb-3 pb-xl-0">
      <!--  OZNAMY  -->
      <div class="row justify-content-center">
        <mat-card class="p-0 py-2 dashboard-upper-card">
          <div class="row">
            <div class="dashboard-card-border">
              <app-squares-vertical-line style="align-self: center"></app-squares-vertical-line>
            </div>
            <div class="dashboard-card-content">
              <div style="text-align: justify">
                <div style="display: flex; flex-direction: row;justify-content: space-between">
                  <h2>OZNAMY</h2>
                  <a [routerLink]="'../announcements'">zobraziť všetky oznamy</a>
                </div>
                <div class="px-2 announcement-content">
                  <ng-container *ngFor="let announcement of announcements; let last = last">
                    <div class="col-12 px-0" [innerHTML]="announcement.text"></div>
                    <mat-divider *ngIf="!last"></mat-divider>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <!--  VUPCH  -->
      <div class="pt-3 row justify-content-center" *ngIf="currentUser?.employee">
        <mat-card class="p-0 py-2 dashboard-upper-card">
          <div class="row">
            <div class="dashboard-card-border">
              <app-squares-vertical-line style="align-self: center"></app-squares-vertical-line>
            </div>
            <div class="dashboard-card-content">
              <div>
                <h2>{{'dashboard.vupch.title' | translate}}</h2>
                <div class="px-2">
                  <div class="row align-items-end justify-content-between">
                    <div class="col-10 px-0">
                      <h3>{{'dashboard.vupch.subtitle' | translate}}</h3>
                      <p>{{'dashboard.vupch.description' | translate}}</p>
                    </div>
                    <div class="col-2 px-0 text-right">
                      <button class="ghost action-button pr-3 edit-button"
                              [routerLink]="'../forms/vupch/' + uuid"
                              [matTooltip]="'common.tooltip.edit' | translate">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button class="ghost action-button"
                              (click)="downloadVUPCH()"
                              [matTooltip]="'common.tooltip.download' | translate">
                        <i class="fas fa-download"></i>
                      </button>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <!--  VTC  -->
    <div class="col-12 col-xl-6 dashboard-upper-card pr-2 pl-0 pl-xl-2 pr-xl-0" *ngIf="currentUser?.employee">
      <mat-card class="pl-0 h-100 dashboard-vtc-card">
        <div class="row justify-content-around dashboard-vtc-row">
          <div class="dashboard-card-border">
            <app-squares-vertical-line style="align-self: center"></app-squares-vertical-line>
          </div>
          <div class="dashboard-card-content pl-0 dashboard-vtc-card-content">
            <div class="dashboard-vtc-panel">
              <div class="row pb-1 justify-content-between align-items-baseline">
                <div class="col-8 px-0">
                  <h2>{{'dashboard.vtc.title--count' | translate: {count: vtcFilterMetadata.count !== 0 ? vtcFilterMetadata.count : 0} }}</h2>
                  <p>{{'dashboard.vtc.description' | translate}}</p>
                </div>
                <div class="col-4 pr-0 text-right">
                  <div class="row justify-content-end">
                    <div class="col-8 mt-n3">
                      <mat-form-field style="font-size: 1rem; width: 100%"
                                      [ngStyle]="isSearchingVTC ? {visibility : 'visible'} : {visibility: 'hidden'}">
                        <mat-label style="display: none"></mat-label>
                        <input matInput #searchVTCInput [(ngModel)]="vtcSearch" name="vtcSearch" (ngModelChange)="onVtcSearchChange()">
                      </mat-form-field>
                    </div>
                    <div class="col-2 px-0">
                      <button *ngIf="!isSearchingVTC else notSearching" (click)="toggleSearchingVTC(true)"
                              class="ghost">
                        <mat-icon class="fas fa-search pt-1" style="font-size: 1rem"></mat-icon>
                      </button>
                      <ng-template #notSearching>
                        <button (click)="toggleSearchingVTC(false)" class="ghost">
                          <mat-icon class="fas fa-times pt-1" style="font-size: 1rem"></mat-icon>
                        </button>
                      </ng-template>
                    </div>
                    <div class="col-2 px-0">
                      <button *ngIf="vtcs && vtcs.length < 15"
                              [routerLink]="'../forms/vtc/new'"
                              [queryParams]="getQueryParams()"
                              [matTooltip]="'common.tooltip.add' | translate"
                              matTooltipPosition="right"
                              class="ghost">
                        <mat-icon class="fas fa-plus pt-1" style="font-size: 1rem"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-0 dashboard-vtc-list-wrapper">
                <div class="programmes-content vtc-programmes-content">
                  <div *ngIf="!vtcs">
                    <mat-spinner class="centered-spinner"></mat-spinner>
                  </div>
                  <cdk-virtual-scroll-viewport itemSize="50" class="list-viewport">
                    <div
                      *cdkVirtualFor="let vtc of vtcs | filterSearchVtc:vtcSearch:vtcFilterMetadata"
                      class="row px-3 pt-2 align-items-end justify-content-between list">
                      <div class="col-9 px-0">
                        <h3 class="clickable-title"
                            [routerLink]="'../forms/vtc/' + vtc.idVtc"
                            [queryParams]="getQueryParamsWithView()">
                          {{vtc.detail | cutTitle}}
                        </h3>
                        <p class="mt-n1 mb-0 pr-1">
                          {{vtc.year}},
                          {{'dashboard.vtc_list.subtitle.study_field' | translate}}:
                          <i>{{vtc.studyField}}</i>,
                          {{vtc.category}}
                        </p>
                      </div>
                      <div class="col-3 px-0 text-right">
                        <button class="ghost action-button edit-button"
                                [routerLink]="'../forms/vtc/' + vtc.idVtc"
                                [queryParams]="getQueryParams()"
                                [matTooltip]="'common.tooltip.edit' | translate">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button class="ghost action-button"
                                (click)="downloadVTC(vtc.idVtc)"
                                [matTooltip]="'common.tooltip.download' | translate">
                          <i class="fas fa-download"></i>
                        </button>
                        <button class="ghost action-button"
                                (click)="deleteVTC(vtc)"
                                [matTooltip]="'common.tooltip.remove' | translate">
                          <i class="fas fa-trash-alt" style="color: rgba(255, 0, 0, 0.6)"></i>
                        </button>
                      </div>
                      <mat-divider class="sp-divider"></mat-divider>
                    </div>
                  </cdk-virtual-scroll-viewport>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>


  <!--  STUDY PROGRAMMES + HIP  -->
  <div class="pt-3 row justify-content-between dashboard-bottom-part">
    <!--    STUDY PROGRAMMES    -->
    <div class="col-12 col-xl-6 px-0 pr-0 pr-xl-2 mb-3 dashboard-bottom-col">
      <mat-card class="p-0 py-2 dashboard-left-card">
        <div class="row">
          <div class="dashboard-programmes-card-content">
            <div class="row px-2 list-title justify-content-between">
              <div class="col-5 px-0">
                <h2>{{'dashboard.study_programme_part.title--count' | translate: {count: spFilterMetadata.count !== 0 ? spFilterMetadata.count : 0} }}</h2>
              </div>
              <div *ngIf="studyProgrammes" class="row justify-content-between col-3 pt-1">
                <app-common-select
                  [ngStyle]="isFiltering ? {visibility : 'visible'} : {visibility: 'hidden'}"
                  #filterInput
                  class="col-8 px-0"
                  [label]="'forms.osp.tabs.basic_data.section.basic_data.input.sp_state.dashboard_label' | translate"
                  [isFirst]="isFiltering"
                  [isDisabled]="false"
                  [options]="state"
                  [required]="false"
                  [elementName]="'stateText'"
                  [objectProperties]="['state']"
                  [formObject]="stateFormHolder"
                  (formChanged)="onFilterChange()">
                </app-common-select>
                <div class="col-2 px-0">
                  <button *ngIf="!isFiltering else notFiltering" (click)="toggleFilter(true)" class="ghost">
                    <mat-icon class="fas fa-filter pt-1" style="font-size: 1rem"></mat-icon>
                  </button>
                  <ng-template #notFiltering>
                    <button (click)="toggleFilter(false)" class="ghost">
                      <mat-icon class="fas fa-times pt-1" style="font-size: 1rem"></mat-icon>
                    </button>
                  </ng-template>
                </div>
              </div>
              <div *ngIf="studyProgrammes" class="col-4 text-right">
                <div class="row justify-content-end">
                  <div class="mt-n3 col-8 dashboard-search-field">
                    <mat-form-field style="font-size: 1rem; width: 100%"
                                    [ngStyle]="isSearchingSp ? {visibility : 'visible'} : {visibility: 'hidden'}">
                      <mat-label style="display: none"></mat-label>
                      <input matInput #searchInput [(ngModel)]="spSearch" name="spSearch" (ngModelChange)="onSearchChange()">

                    </mat-form-field>
                  </div>
                  <div class="col-2 px-0">
                    <button *ngIf="!isSearchingSp else notSearching" (click)="toggleSearchingSp(true)" class="ghost">
                      <mat-icon class="fas fa-search pt-1" style="font-size: 1rem"></mat-icon>
                    </button>
                    <ng-template #notSearching>
                      <button (click)="toggleSearchingSp(false)" class="ghost">
                        <mat-icon class="fas fa-times pt-1" style="font-size: 1rem"></mat-icon>
                      </button>
                    </ng-template>
                  </div>
                  <div *ngIf=" isCurrentUserEvaluator()" class="col-2 px-0">
                    <button  [routerLink]="'../forms/osp/new'"
                            [matTooltip]="'common.tooltip.add' | translate"
                             matTooltipPosition="right"
                             class="ghost">
                      <mat-icon class="fas fa-plus pt-1" style="font-size: 1rem"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="programmes-content">
              <div *ngIf="!studyProgrammes">
                <mat-spinner class="centered-spinner"></mat-spinner>
              </div>
              <cdk-virtual-scroll-viewport itemSize="50" class="list-viewport">
                <div
                  *cdkVirtualFor="let programme of studyProgrammes| filterStudyProgrammeSearch:spSearch:stateFormHolder.state:spFilterMetadata"
                  class="row pr-3 align-items-end justify-content-between list">
                  <div class="d-flex px-0" style="margin: 0.5% 0"
                       [ngStyle]="{'border-left': '4px solid '+programme.faculty.color }">
                    <div class="faculty-row py-1">
                      <div class="ml-2">
                        <h3 class="clickable-title"
                            [routerLink]="'../forms/osp/sp/' + programme.idStudyProgramme"
                            [queryParams]="getQueryParamsWithView()"
                            [ngClass]="programme.faculty.acronym">
                          {{ programme.title | title }}
                        </h3>
                        <p class="mt-n1 mb-0 pr-1">
                          {{programme.faculty.name}},
                          {{'dashboard.study_programme_part.sp_subtitle.study_field' | translate}}
                          <i>{{programme.studyField}}{{programme.studyField2 ? '+' + programme.studyField2 : ''}}</i>,
                          {{programme.degree}}
                          {{'dashboard.study_programme_part.sp_subtitle.degree' | translate}},
                          {{programme.formOfStudy === 'PRESENT' ? ('forms.osp.tabs.basic_data.section.basic_data.input.form_of_study.present'| translate | lowercase)
                          : ('forms.osp.tabs.basic_data.section.basic_data.input.form_of_study.external'| translate | lowercase) }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="row justify-content-end">
                      <div class="mr-3 d-flex">
                        <div class="numberCircle"
                             [matTooltip]="'common.tooltip.guarantees--count' | translate: {count: programme.guaranteesCount}"
                             [ngClass]="programme.guaranteesCount === 0 ? 'number-danger' :programme.guaranteesCount === 5 ? 'number-ok' : 'number-warning'">
                          {{programme.guaranteesCount}}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div style="display: flex;justify-content: right">
                          <button class="ghost action-button edit-button mr-1"
                                  *ngIf="isCurrentUserEvaluator()"
                                  [routerLink]="'../forms/osp/evaluations/' + programme.idStudyProgramme"
                                  [queryParams]="getQueryParams()"
                                  [matTooltip]="'common.tooltip.evaluation' | translate">
                            <i class="fas fa-star-half-alt"></i>
                          </button>
                          <button class="ghost action-button edit-button mr-1"
                                  [routerLink]="'../forms/osp/commission/' + programme.idStudyProgramme"
                                  [queryParams]="getQueryParams()"
                                  [matTooltip]="'common.tooltip.write' | translate">
                            <i class="far fa-file-pdf"></i>
                          </button>
                          <button class="ghost action-button edit-button"
                                  [routerLink]="'../forms/osp/sp/' + programme.idStudyProgramme"
                                  [queryParams]="getQueryParams()"
                                  [matTooltip]="'common.tooltip.edit' | translate">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="ghost action-button edit-button"
                                  [routerLink]="'../forms/osp/sp/' + programme.idStudyProgramme"
                                  [queryParams]="getQueryParamsWithView()"
                                  [matTooltip]="'common.tooltip.view' | translate">
                            <i class="fas fa-external-link-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <mat-divider class="sp-divider"></mat-divider>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <!--    HIP    -->
    <div class="col-12 col-xl-6 px-0 pl-0 pl-xl-2 dashboard-bottom-col">
      <mat-card class="p-0 py-2 dashboard-right-card">
        <div class="row">
          <div class="dashboard-programmes-card-content">
            <div class="row px-2 list-title">
              <div class="col-7 px-0">
                <h2>{{'dashboard.hip_part.title--count' | translate: {count: hipFilterMetadata?.count} }}</h2>
              </div>
              <div *ngIf="hips" class="col-5 text-right">
                <div class="row justify-content-end">
                  <div class="mt-n3 col-8 dashboard-search-field">
                    <mat-form-field style="font-size: 1rem; width: 100%"
                                    [ngStyle]="isSearchingHip ? {visibility : 'visible'} : {visibility: 'hidden'}">
                      <mat-label style="display: none"></mat-label>
                      <input matInput #searchHipInput [(ngModel)]="hipSearch" name="hipSearch" (ngModelChange)="onHipSearchChange()">
                    </mat-form-field>
                  </div>
                  <div class="col-4 dashboard-search-toggle">
                    <button *ngIf="!isSearchingHip else notSearchingHip" (click)="toggleSearchingHip(true)"
                            class="ghost">
                      <mat-icon class="fas fa-search pt-1" style="font-size: 1rem"></mat-icon>
                    </button>
                    <ng-template #notSearchingHip>
                      <button (click)="toggleSearchingHip(false)" class="ghost">
                        <mat-icon class="fas fa-times pt-1" style="font-size: 1rem"></mat-icon>
                      </button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <div class="programmes-content">
              <div *ngIf="!hips">
                <mat-spinner class="centered-spinner"></mat-spinner>
              </div>
              <cdk-virtual-scroll-viewport itemSize="50" class="list-viewport">
                <div *cdkVirtualFor="let hip of hips| filterSearchHip:hipSearch:hipFilterMetadata"
                     class="row pr-3 align-items-end justify-content-between list">
                  <div class="col-10 px-0" style="margin: 0.5% 0"
                       [ngStyle]="{'border-left': '4px solid '+hip.faculty.color }">
                    <div class="faculty-row py-1">
                      <div class="ml-2">
                        <h3 class="clickable-title"
                            [routerLink]="'../forms/hip/' + hip.idHabilitationInauguration"
                            [queryParams]="getQueryParamsWithView()"

                            [ngClass]="hip.faculty.acronym">
                          {{ hip.title | title }}
                        </h3>
                        <p class="mt-n1 mb-0 pr-1">
                          {{hip.faculty.name}},
                          {{'dashboard.study_programme_part.sp_subtitle.study_field' | translate}}
                          <i>{{hip.studyField}}{{hip.studyField2 ? '+' + hip.studyField2 : ''}}</i>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 px-0 text-right">
                    <div class="row">
                      <div class="col-6 text-right">
                        <div class="numberCircle"
                             [matTooltip]="'common.tooltip.guarantees--count' | translate: {count: hip.guaranteesCount}"
                             [ngClass]="hip.guaranteesCount === 0 ? 'number-danger' :hip.guaranteesCount === 5 ? 'number-ok' : 'number-warning'">
                          {{hip.guaranteesCount}}
                        </div>
                      </div>
                      <div class="col-6 px-0">
                        <div style="display: flex">
                          <button class="ghost action-button edit-button"
                                  [routerLink]="'../forms/hip/' + hip.idHabilitationInauguration"
                                  [queryParams]="getQueryParams()"
                                  [matTooltip]="'common.tooltip.edit' | translate">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button class="ghost action-button edit-button"
                                  [routerLink]="'../forms/hip/' + hip.idHabilitationInauguration"
                                  [queryParams]="getQueryParamsWithView()"
                                  [matTooltip]="'common.tooltip.view' | translate">
                            <i class="fas fa-external-link-alt"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <mat-divider class="sp-divider"></mat-divider>
                </div>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
